import { render, staticRenderFns } from "./Personalprofile.vue?vue&type=template&id=5caacfe3&scoped=true"
import script from "./Personalprofile.vue?vue&type=script&lang=js"
export * from "./Personalprofile.vue?vue&type=script&lang=js"
import style0 from "./Personalprofile.vue?vue&type=style&index=0&id=5caacfe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caacfe3",
  null
  
)

export default component.exports